var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.maintenanceWindow)?_c('div',{staticClass:"maintenance-banner"},[_vm._v(" "+_vm._s(_vm.maintenanceWindow)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }